export default "__VITE_ASSET__C3sIEXjC__"